// tslint:disable: max-line-length
import { Component } from "@angular/core";

import { TCITenantSelectorType, TCITenantAppType, ITCIConnection } from "@tci/common";
import {
    TCITenantComponentInput,
    TCITenantComponentOutput,
    ITCIConnectionDeleteComponentInput,
    ITCIConnectionDeleteComponentOutput
} from "../../ng-tenant/tci-tenant-components";
import { AbstractTCITenantComponent } from "../../ng-tenant/tci-tenant-component";

export class BaseConnectionDeleteComponentInput extends TCITenantComponentInput implements ITCIConnectionDeleteComponentInput {
    /**
     * @param tenantAppType
     * @param componentSelector
     * @param connection
     */
    constructor(
        public tenantAppType: TCITenantAppType,
        public componentSelector: TCITenantSelectorType,
        public connection: ITCIConnection
    ) {
        super();
    }

    getConnection(): ITCIConnection {
        return this.connection;
    }
}

export class BaseConnectionDeleteComponentOutput<E> extends TCITenantComponentOutput<E> implements ITCIConnectionDeleteComponentOutput<E> {
    constructor() {
        super();
    }
}

@Component({
    selector: TCITenantSelectorType.TCI_CONN_LIST_CONN_DELETE.toString(),
    templateUrl: "./base-connection-delete.component.html"
})
export class BaseConnectionDeleteComponent<E, I extends BaseConnectionDeleteComponentInput, O extends BaseConnectionDeleteComponentOutput<E>> extends AbstractTCITenantComponent<E, I, O>  {
    constructor() {
        super();
    }
}
